import styled from 'styled-components';
import glow from '../../assets/images/menu_glow.png';

const StyledContainer = styled.div<{ $scrollable?: boolean }>`
	position: relative;
	width: auto;
	min-width: 0;
	max-width: fit-content;
	height: 122px;
	display: flex;
	gap: 40px;
	overflow-x: ${({ $scrollable }) => ($scrollable ? 'scroll' : 'hidden')};
	overflow-y: hidden;

	/* @media (max-width: 1570px) {
		gap: 20px;
	} */

	&::-webkit-scrollbar {
		display: none;
	}
`;

const StyledGlow = styled.div`
	width: 150px;
	height: 140px;
	background-image: url(${glow});
	background-size: 150px 140px;
	background-position: center;
	background-repeat: no-repeat;
	position: fixed;
	top: 0;
	left: 0;
	transition:
		opacity 0.3s ease,
		left 0.3s ease,
		top 0.3s ease,
		transform 0.3s ease;
	pointer-events: none;
	z-index: 9999;
`;

export { StyledContainer, StyledGlow };
